import React, { createContext, useEffect, useMemo, useState } from 'react';
import { apiFetch } from '../Helpers/api';

export const AuthContext = createContext({
  user: null,
  loading: true,
  login: async () => {},
  register: async () => {},
  logout: async () => {},
  setAuthenticatedUser: () => {},
  refreshUser: async () => {},
});

async function authRequest(path, options = {}) {
  const response = await apiFetch(path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const json = await response.json();

  if (!response.ok) {
    throw new Error(`${path}: ${json.error || 'Authentication request failed.'}`);
  }

  return json;
}

const AuthContextProvider = (props) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function refreshUser() {
    const json = await authRequest('me.php', { method: 'GET' });
    setUser(json.data?.user || null);
    return json.data?.user || null;
  }

  useEffect(() => {
    refreshUser()
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  async function login(credentials) {
    const json = await authRequest('login.php', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
    setUser(json.data?.user || null);
    return json.data?.user || null;
  }

  async function register(account) {
    const json = await authRequest('register.php', {
      method: 'POST',
      body: JSON.stringify(account),
    });
    setUser(json.data?.user || null);
    return json.data?.user || null;
  }

  async function logout() {
    await authRequest('logout.php', { method: 'POST' });
    setUser(null);
  }

  function setAuthenticatedUser(nextUser) {
    setUser(nextUser || null);
  }

  const value = useMemo(() => ({
    user,
    loading,
    login,
    register,
    logout,
    setAuthenticatedUser,
    refreshUser,
  }), [user, loading]);

  return (
    <AuthContext.Provider value={value}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
